import { useContext, useMemo } from 'react'
import { CustomizationContext } from '../../../context/CustomizationContextProvider'
import { Star } from '../../icons/Star'

export const ReviewStar: React.FC<{
    rating: number
    fillColor?: string
    starWidth?: number
}> = ({ rating, fillColor, starWidth }) => {
    const { reviewStarColorOverride, accentFillColor } =
        useContext(CustomizationContext)

    const stars = useMemo(() => {
        const ar = [1, 2, 3, 4, 5]
        const width = starWidth || 18
        const fill = fillColor || reviewStarColorOverride || accentFillColor

        return ar.map((n, i) => {
            if (n <= rating) {
                return (
                    <div
                        key={i}
                        style={{
                            marginRight: '2px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Star
                            fillPercentage={100}
                            width={width}
                            fillColor={fill}
                        />
                    </div>
                )
            } else if (n - rating < 1) {
                return (
                    <div
                        key={i}
                        style={{
                            marginRight: '2px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Star
                            fillPercentage={(1 - (n - rating)) * 100}
                            width={width}
                            fillColor={fill}
                        />
                    </div>
                )
            } else {
                return (
                    <div
                        key={i}
                        style={{
                            marginRight: '2px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Star
                            fillPercentage={0}
                            width={width}
                            fillColor={fill}
                        />
                    </div>
                )
            }
        })
    }, [rating, starWidth, fillColor, reviewStarColorOverride, accentFillColor])

    return <div style={{ display: 'flex' }}>{stars}</div>
}
